import i18n from '../../utils/i18n.ts';

export const getMenu = ({ email }: { email: string }) => [
  {
    name: i18n.t('common.main-portal'),
    path: 'https://gi7.sharepoint.com',
    key: 1,
  },
  {
    name: i18n.t('common.portal'),
    path: '/',
    key: 2,
  },
  {
    name: i18n.t('common.help-center'),
    path: 'https://gi7.sharepoint.com/sites/Arbeitsgrundlagen-wiki/Seiten/home.aspx',
    key: 3,
  },
  {
    name: i18n.t('common.contact-us'),
    path: `mailto:${email}`,
    key: 4,
  },
  {
    name: 'Admin Panel',
    path: '/admin',
    key: 5,
  },
];
